export default __webpack_public_path__ + "static/media/auto_stories.5e315e17.svg";